'use client';

import { EmployeeSearchAdvanceResponse } from '@/server/api/v1/employee/type';
import { LogicalOperator, OperatorType } from '@/server/base/base-trpc-service';
import { api } from '@/trpc/client';
import { EmployeeExpand } from '@/types/enum';
import { useCallback } from 'react';
import { CachedNamespace, useCachedData } from './use-cached-local';

export const useCachedLocalEmployeeInfo = () => {
    const apiUtils = api.useUtils();

    const onFetchEmpInfo = useCallback(
        async (empIds: string[]) => {
            const result = await apiUtils.employee.SearchEMPAdvance.fetch({
                limit: empIds.length,
                countMaxTo: empIds.length,
                countTotal: false,
                filters: [
                    {
                        key: 'ID',
                        values: empIds,
                        logicalOperator: LogicalOperator.And,
                        operatorType: OperatorType.In,
                    },
                ],
                isIncludeSelf: true,
                expands: [
                    EmployeeExpand.Department,
                    EmployeeExpand.Position,
                    EmployeeExpand.Unit,
                ],
            });

            return result.data?.Items ?? [];
        },
        [apiUtils.employee.SearchEMPAdvance]
    );

    return useCachedData<EmployeeSearchAdvanceResponse>({
        namespace: CachedNamespace.EmpInfos,
        queryFn: onFetchEmpInfo,
    });
};
